import React from "react";
import InlineDropdown from "./InlineDropdown";

export const OPPORTUNITY_DATE_BASIS = {
  CREATED: "created_date",
  UPDATED: "updated_date",
};

export const OPPORTUNITY_DATE_BASIS_OPTIONS = [
  { label: "Created on", key: OPPORTUNITY_DATE_BASIS.CREATED },
  { label: "Updated on", key: OPPORTUNITY_DATE_BASIS.UPDATED },
];

/**
 * Inline dropdown preconfigured for "Created on / Updated on" selection,
 * used by the Opportunity by Sales Person view.
 *
 * @param {{
 *   value: "created_date" | "updated_date",
 *   onChange: (value: string) => void,
 *   className?: string,
 * }} props
 */
const OpportunityDateBasisDropdown = ({ value, onChange, className }) => (
  <InlineDropdown
    value={value}
    onChange={onChange}
    options={OPPORTUNITY_DATE_BASIS_OPTIONS}
    placeholder="Created on"
    className={className}
  />
);

export default OpportunityDateBasisDropdown;
